export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/d50cc34e778c6c20c755dccf4a153599.svg";